<app-header></app-header>
<div class="app">
    <router-outlet></router-outlet>
</div>
<button i18n class="d-none btn manage-cookie" [class.isDetailsPage] = "isDetailsPage" (click) = "showCookie()">Manage Cookies</button>
<app-footer [class.isDetailsPageFoot] = "isDetailsPage" [pathname] = "pathname"></app-footer>
